<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3 class="mt-5">{{ $store.getters['setup/currentAddressDecoded'].full}}</h3>
                <hr>
               
                <current ref="current" />
                <div class="row">
                    <div class="col-8 col-lg-4 mx-auto">
                        <button class="btn btn-outline-info btn-lg btn-block px-5 my-3" @click="$router.push({name: 'ProfileSettings',  params: {property: $route.params.property}})">Back</button>
                    </div>
                    <div class="col-8 col-lg-4 mx-auto">
                        <button class="btn btn-success btn-success-gradient btn-lg btn-block px-5 my-3" @click="updateChoice">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/utils/api";
import {each} from 'lodash'
import SetupChoiceUpdate from "@/mixins/SetupChoiceUpdate";
import store from '@/store'
import Current from "@/views/setup/Current";

export default {
    name: "SupplyUpdate",
    components: {Current},
    mixins: [SetupChoiceUpdate],
    data() {
        return {
        }
    },
    methods: {
        energySourceIs: function (sourceType) {
            if (!Array.isArray(sourceType)) {
                sourceType = [sourceType]
            }
            return sourceType.indexOf(this.$store.getters['setup/choice'].currentEnergySource) >= 0
        },
        updateChoice: function (){
            let that = this;
            this.$refs.current.validate();
            console.log(Object.values(this.$refs.current.errors), Object.values(this.$refs.current.errors).filter(v => !!v.length).length);
            if(!Object.values(this.$refs.current.errors).filter(v => !!v.length).length){
                api.updatePropertySupply(this.$route.params.property, this.$store.getters['setup/choice']).then(() => {
                    that.$toast.success("Supply details updated!")
                    that.$router.push({name: 'ProfileSettings', params: {
                        property: this.$route.params.property
                        }})
                }).catch(() => {
                    that.$toast.error('Problem with updating details!')
                })
            } else {
                this.$nextTick(function () {
                    let errors = window.document
                        .querySelector('.invalid-feedback, .invalid-tooltip');
                    let boundingClientRect = errors
                        .closest('.choice-wrap')
                        .getBoundingClientRect();
                    window.scrollTo({
                        top: (boundingClientRect.top + window.document.documentElement.scrollTop) - 120,
                        left: boundingClientRect.left,
                        behavior: 'smooth'
                    })
                });
            }
            
        }
    },
    computed: {
        data: function () {
            return this.$store.getters["setup/stepTwoData"]
        },
        choice() {
            return this.$store.getters['setup/choice'];
        }
    },
    mounted() {
        let that = this;
        if(this.$store.getters['setup/isDataEmpty']){
            api.survey().then(response => {
                that.$store.commit('setup/setData', response.data.data)
            })
        }
        
        if(!this.data.suppliers.length){
            api.suppliers().then(result => {
                that.$store.commit('setup/setSuppliers', result.data.data)
            })
        }
    },
    beforeRouteEnter: (to, from, next) => {
        api.property(to.params.property).then(response => {
    
            let details = {
                ...response.data.data,
                ...response.data.data.usage
            }
    
            let choice = store.getters['setup/choice']
    
            each(choice, function (v,k){
                choice[k] = details[k]
            })
    
            let payload = JSON.parse( atob(choice.currentPropertyAddressPayload));
            const addressDetails = {
                line1: payload.full,
                town: payload.town,
                postcode: payload.postcode
            }
            
            
            api.propertyTariff(to.params.property).then(response => {
                
                if(response.data.data.d){
                    let supply = response.data.data.d;
                    choice.currentElectricitySupplier = supply.product.supplier.id;
                    choice.currentGasSupplier = supply.product.supplier.id;
                    choice.currentElectricityTariff = supply.product.id;
                    choice.currentGasTariff = supply.product.id;
                }
                if(response.data.data.e){
                    let supply = response.data.data.e;
                    choice.currentElectricitySupplier = supply.product.supplier.id;
                    choice.currentElectricityTariff = supply.product.id;
                }
                if(response.data.data.g){
                    let supply = response.data.data.g;
                    choice.currentGasSupplier = supply.product.supplier.id;
                    choice.currentGasTariff = supply.product.id;
                }
    
                store.commit('setup/setChoice', choice)
                store.commit('setup/setAddress', addressDetails)
                next()
            })
            
        }).catch(() => {
            next({name: 'ProfileSettings'})
        })
        
        
    },
    beforeRouteLeave: function (to, from, next){
        this.$store.commit('setup/clearChoice')
        if(to.name === 'ProfileSettings' && this.$route.params.property) {
            to.params['property'] = this.$route.params.property
        }
        next()
    }
}
</script>

<style scoped>

</style>
